import { Layout } from 'react-grid-layout';
import {
  ComponentTypes,
  DyProductSource,
  IAssemblyComponent,
  ISectionConfig,
} from 'src/interfaces';
import { IScheduleItemOverride } from 'src/interfaces/Schedule';

export interface IPositionGridLines {
  position: number;
  duration: number;
  gridLines: string[];
}

interface IScheduleDates {
  isDeletable?: boolean;
  scheduleStartDate?: string | null;
  scheduleEndDate?: string | null;
}

export interface IScheduledSectionBackupComponent
  extends IAssemblyComponent,
    IScheduleDates {}

export interface IScheduledSectionComponent
  extends IAssemblyComponent,
    IScheduleDates {
  backups?: IScheduledSectionBackupComponent[];
  override?: IScheduleItemOverride;
  isOverridden?: boolean;
}

export interface IDefaultSection {
  i: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  screenId?: number;
  channel_screen_sequence?: number;
  name?: string;
  height?: number;
  width?: number;
  topOffset?: number;
  leftOffset?: number;
  config?: ISectionConfig;
  components?: IScheduledSectionComponent[];
  isDisclaimer?: boolean;
  isDYR?: boolean;
  canBeDeleted?: boolean;
  canBeScheduled?: boolean;
}
export interface IGridSection
  extends Layout,
    Omit<IDefaultSection, 'x' | 'y' | 'w' | 'h'> {}

export interface TScreensGridSections {
  [position: string]: {
    [screenIndex: string]: (IGridSection | IDefaultSection)[];
  };
}

export interface IPredefinedSection {
  i: string;
  name: string;
  height: number;
  width: number;
  topOffset: number;
  leftOffset: number;
  config?: ISectionConfig;
  isDisclaimer: boolean;
  isDYR?: boolean;
  canBeDeleted: boolean;
  canBeScheduled?: boolean;
  screenId: number;
}

export type TSuggestedComponentTypes = (ComponentTypes | DyProductSource)[];

export type TSectionPayload = (IGridSection | IDefaultSection) &
  Omit<IPositionGridLines, 'gridLines'>;
export enum ChangeOperation {
  INSERT = 'insert',
  UPDATE = 'update',
  DELETE = 'delete',
}

export type ChangeType = 'schedule_item' | 'schedule_item_override';

export enum ChangeTypeEnum {
  SCHEDULE_ITEM = 'schedule_item',
  SCHEDULE_ITEM_OVERRIDE = 'schedule_item_override',
}
export interface ChangeItem<T = any> {
  type: ChangeType;
  op: ChangeOperation;
  id?: number | null;
  data: T;
}

export interface ChangeSetPayload {
  location_group_ids: number[];
  location_code?: string;
  daypart_id?: number;
  changes: ChangeItem[];
}

export interface ChangeSetUpdatePayload {
  changes: ChangeItem[];
}

export interface BuildChangeSetArgs {
  locationGroupIds: number[];
  daypartId?: number;
  scheduleChanges?: ChangeItem[];
  scheduleItemChanges?: ChangeItem[];
  scheduleItemOverrideChanges?: ChangeItem[];
}
